declare var $: any;

import {Autosave} from "../modules/autosave";

export class InvestmentAdvice {
    static init() {
        $(Autosave.containerPageClass).on("reloaded", InvestmentAdvice.bindEvents);
        InvestmentAdvice.bindEvents();
    }

    static bindEvents() {
        $(".cashflow-results-group h4").click(InvestmentAdvice.toggleCashflowResultsGroup);
    }

    static toggleCashflowResultsGroup() {
        const div = $(this).parent("div");
        div.toggleClass("open");
        const table = div.find(".table-hide");

        if (div.hasClass("open")) {
            table.slideDown(250);
        } else {
            table.slideUp(200);
        }
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/partials/investmentAdvice.ts